<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Galeria de Mídia" pageTitle="Galeria" />
            <GalleryContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import GalleryContent from '../Gallery/GalleryContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'MediaGalleryPage',
    components: {
        MainHeader,
        PageTitle,
        GalleryContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>
